import { AxiosRequestConfig, CancelToken } from 'axios';
import {
  DownloadFileLogicalNameType,
  DownloadFilesAsZipData,
  GetFilesByDocumentTypeData,
  GetLogoData,
  UpdateFileProviderData,
  UploadFilesProps
} from './file-provider.types';
import { DownloadType } from '../../constants';

class FileProviderRequestConfig {
  uploadFiles = ({ files, entityId, documentTypeId, logicalName }: UploadFilesProps): AxiosRequestConfig => {
    const data = new FormData();
    files.forEach(file => {
      data.append('files', file, file.name);
    });
    data.append('entityId', entityId);
    data.append('documentTypeId', documentTypeId);
    data.append('logicalName', logicalName);

    return {
      method: 'POST',
      url: 'fileProvider/uploadFiles',
      responseType: 'blob',
      data
    };
  };

  moveToRecycleBin = (logicalName: string, storageFileId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fileProvider/moveToRecycleBin',
    responseType: 'blob',
    data: {
      logicalName,
      storageFileId
    }
  });

  downloadFile = (
    storageFileId: string,
    logicalName: DownloadFileLogicalNameType,
    downloadType: DownloadType
  ): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fileProvider/DownloadFile',
    responseType: 'blob',
    data: {
      storageFileId,
      logicalName,
      downloadType
    }
  });

  getFilesByDocumentType = (data: GetFilesByDocumentTypeData): AxiosRequestConfig => ({
    method: 'POST',
    url: `fileProvider/getFilesByDocumentType`,
    data
  });

  getLogo = (data: GetLogoData, cancelToken: CancelToken): AxiosRequestConfig => ({
    method: 'POST',
    url: `fileProvider/getLogo`,
    responseType: 'blob',
    cancelToken,
    data,
    transformResponse: function (data) {
      if (data.type === 'application/json') {
        return '';
      }
      const urlCreator = window.URL || window.webkitURL;
      return urlCreator.createObjectURL(data);
    }
  });

  updateFileProvider = (updateFileProviderData: UpdateFileProviderData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fileProvider/update',
    data: {
      fileProvider: updateFileProviderData
    }
  });

  downloadFilesAsZip = (data: DownloadFilesAsZipData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fileProvider/downloadFilesAsZip',
    responseType: 'blob',
    data
  });
}

export const fileProviderRequestConfig = new FileProviderRequestConfig();
